import * as styles from "./TableView.style.ts";
import { Fragment } from "react";
import { Flex } from "src/components/Flex.tsx";
import { TextV2 } from "src/components/TextV2/TextV2.tsx";
import { useTranslation } from "react-i18next";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";

export type CommentsTableRow = {
  id: string;
  author: string;
  date: string;
  content: string;
};

export const TableView = ({ rows }: { rows: CommentsTableRow[] }) => {
  const { t } = useTranslation(TranslationNamespaceEnum.CommentsFormPanel);
  return (
    <div css={styles.root}>
      <div css={styles.header({ position: "start" })}>
        <TextV2 variant={"body1"}>{t("table.columns.author.title")}</TextV2>
      </div>
      <div css={styles.header({ position: "end" })}>
        <TextV2 variant={"body1"}>{t("table.columns.comment.title")}</TextV2>
      </div>

      {rows.map((comment) => (
        <Fragment key={comment.id}>
          <div css={styles.cell}>
            <Flex flexDirection={"column"}>
              <TextV2 fontWeight={"medium"} variant={"body1"}>
                {comment.author}
              </TextV2>
              <TextV2 variant={"body2"}>{comment.date}</TextV2>
            </Flex>
          </div>
          <div css={styles.cell}>
            <TextV2 variant={"body1"}>{comment.content}</TextV2>
          </div>
        </Fragment>
      ))}
    </div>
  );
};
